// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"c7699925d9ebe6f523c5","5338":"7f0908be28d30055196a"}[chunkId] + ".js";
};